module.exports = __webpack_public_path__ + "static/media/helvetica.30ba93c7.woff2";